import CloseIcon from '@mui/icons-material/Close';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import TuneSharpIcon from '@mui/icons-material/TuneSharp';
import { Button, Dialog, FormControlLabel, IconButton, Slide, Stack } from '@mui/material';
import React, { forwardRef, useState } from 'react';

import CheckboxSelectField from '../CheckboxSelectField/CheckboxSelectField';
import ColumnDropdown from '../ListActionBar/ColumnDropDown';
import ControlledCheckbox from 'FRONTEND/components/ControlledCheckbox';
import i18n from 'FRONTEND/utils/i18n';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const FilterDialog = ({
  formattedOptions = [],
  formattedValues = [],
  onFilterChange,
  commentsOnly,
  commentsFunction,
  hasColumnDropdown,
  dataTable,
}) => {
  const [open, setOpen] = useState(false);

  const handleFilterButtonClick = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className='filterDialog-button'>
        <Button
          variant='contained'
          color='inherit'
          onClick={handleFilterButtonClick}
          startIcon={<TuneSharpIcon className='downloadDropdown-icon' />}
          endIcon={<DownIcon />}
        />
      </div>
      <Dialog fullWidth className='filterDialog' maxWidth={false} open={open} onClose={handleDialogClose} TransitionComponent={Transition}>
        <div className='filterDialog-title'>
          {i18n._('Filters')}
          <IconButton onClick={handleDialogClose} aria-label='close' size='large'>
            <CloseIcon />
          </IconButton>
        </div>
        <Stack spacing={2} sx={{ p: 2 }}>
          {formattedOptions.length > 0 && (
            <CheckboxSelectField
              options={formattedOptions}
              selectedValues={formattedValues}
              placeholder={i18n._('No filter applied')}
              selectedPlaceholder={i18n._('Filters applied')}
              onChange={onFilterChange}
              showSelectAll={false}
            />
          )}
          {commentsOnly && (
            <FormControlLabel
              control={
                <ControlledCheckbox
                  defaultChecked={commentsOnly.checked === 'True'}
                  onChange={(event) => {
                    commentsFunction(event.target.checked, commentsOnly.url);
                  }}
                />
              }
              label={commentsOnly.label}
            />
          )}
          {hasColumnDropdown && (
            <ColumnDropdown datatable={dataTable} label={i18n._('Columns')} />
          )}
        </Stack>
      </Dialog>
    </>
  );
};

export default FilterDialog;
